import { Input } from "antd";
import React, { useState, useRef, useCallback } from "react";

function DebounceInput(props) {
  const {
    placeholder,
    value,
    className,
    type,
    name,
    id,
    required,
    onChange,
    defaultValue,
    reference,
    label,
    labelClasses,
    allowClear,
    suffix,
    debounceTime = 300, // Default debounce time
  } = props;

  const [debouncedValue, setDebouncedValue] = useState(value || defaultValue);
  const debounceTimeout = useRef(null);

  const handleChange = useCallback(
    e => {
      const newValue = e.target.value;
      setDebouncedValue(newValue);

      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        if (onChange) {
          onChange(newValue); // Return only the debounced value
        }
      }, debounceTime);
    },
    [onChange, debounceTime]
  );

  return (
    <>
      {label && (
        <label className={labelClasses}>
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <Input
        className={`w-full ${className}`}
        type={type}
        name={name}
        id={id}
        required={required}
        placeholder={placeholder}
        value={debouncedValue}
        onChange={handleChange}
        defaultValue={defaultValue}
        ref={reference}
        allowClear={allowClear}
        suffix={suffix}
      />
    </>
  );
}

export default DebounceInput;
